import { twMerge } from "@/utils/twMerge";

export function ChatUnreadMessagesCount({
  count,
  className,
  pinTopRight,
}: {
  count: number;
  className?: string;
  pinTopRight?: boolean;
}) {
  if (count === 0 || !count) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "pointer-events-none flex items-center justify-center min-w-[17px] h-[17px] px-1 rounded-full bg-rose-500 font-mono text-[13px] leading-0 text-center text-white tracking-tight",
        "sm:min-w-[20px] sm:h-[20px] sm:text-[15px]",
        pinTopRight && "absolute z-10 top-0 right-0",
        className,
      )}
    >
      <div className="m-auto pb-[0.5px]">{count > 99 ? "99+" : count}</div>
    </div>
  );
}
